import React from 'react'
import { Link } from 'react-router-dom'
import './ServicesList.scss'

const ServicesList = ({ currentService = null }) => {
	const services = [
		{
			id: 'integration-animation',
			title: 'Intégration & Animation',
			description: 'Création d\'interfaces web modernes et dynamiques avec animations fluides et interactions soignées.',
			details: 'Spécialistes Vue, React, GSAP, Anime.js, Three.js pour des expériences utilisateur mémorables.',
			url: '/services/integration-animation'
		},
		{
			id: 'tma-support',
			title: 'TMA & Support',
			titleFull: 'Tierce Maintenance Applicative & Support',
			description: 'Maintenance et évolution de vos sites existants pour garantir leur pérennité.',
			details: 'Corrections, améliorations, optimisations et mises à jour régulières.',
			url: '/services/tma-support'
		},
		{
			id: 'wordpress-ecommerce',
			title: 'WordPress & E-commerce',
			description: 'Création de sites et boutiques en ligne sur-mesure avec WordPress, WooCommerce ou Shopify.',
			details: 'Thèmes personnalisés, fonctionnalités avancées.',
			url: '/services/wordpress-ecommerce'
		},
		{
			id: 'applications-web',
			title: 'Applications web complexes',
			description: 'SPA/PWA avec React/Vue, Server-Side Rendering (Next.js/Nuxt), WebSockets temps réel, Architecture microservices, API Gateway, etc.',
			url: '/services/applications-web'
		},
		{
			id: 'projets-creatifs-iot',
			title: 'Projets créatifs & IoT',
			description: 'Nous aimons aussi explorer : interfaces pour projets Arduino ou Raspberry Pi, installations interactives et tactiles.',
			details: 'Parlons de vos idées créatives et trouvons ensemble la meilleure solution technique.',
			url: '/services/projets-creatifs-iot'
		}
	]

	const filteredServices = currentService 
		? services.filter(service => service.id !== currentService)
		: services

	const gridClass = filteredServices.length === 4 ? 'services-grid-4' : 'services-grid-5'

	return (
		<section className='services-list'>
			<h2 className='align-center'>
				{currentService ? 'Découvrez aussi nos autres services' : 'Pour aller plus loin'}
			</h2>
			<p className='align-center light'>
				{currentService 
					? 'Des solutions adaptées à tous vos besoins numériques'
					: 'Des services techniques pour les projets complexes et les équipes tech'
				}
			</p>
			
			<div className={`services-list-grid ${gridClass}`}>
				{filteredServices.map(service => (
					<Link 
						key={service.id}
						to={`${process.env.PUBLIC_URL}${service.url}`}
						className='service-card'
					>
						<h3>
							{service.titleFull ? (
								<>
									<abbr title={service.titleFull}>{service.title.split(' & ')[0]}</abbr>
									{' & ' + service.title.split(' & ')[1]}
								</>
							) : (
								service.title
							)}
						</h3>
						<p className='light'>
							{service.description}
							{service.details && (
								<>
									<br />
									{service.details}
								</>
							)}
						</p>
						<span className='service-card-link link'>En savoir plus</span>
					</Link>
				))}
			</div>
		</section>
	)
}

export default ServicesList